import React from 'react';
import { FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import messages from './messages';
import './styles.css';

const NotificationsRequestsNoResults = () => (
  <Grid centered stretched styleName="notification-no-results-grid">
    <Grid.Row>
      <Grid.Column width={10} styleName="notification-no-results-row">
        <FormattedMessage {...messages.requestsNoResults} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default NotificationsRequestsNoResults;
